/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type PriceListItemsDestroyRequest = {} | null | undefined;
export type PriceListItemsDestroyResponse = any;

export type PriceListItemsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this price list item.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_destroy
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '400':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             type: object
 *             properties:
 *               message:
 *                 type: string
 *               code:
 *                 type: string
 *             required:
 *               - message
 *               - code
 *     description: >-
 *       Položka je navázaná na výdejní sadu nebo objednávku služby/tisku — mazání
 *       je blokováno (code: vydej_price_list_item_in_use,
 *       vydej_price_list_item_in_use_by_service_order).
 * ```
 */
export const priceListItemsDestroyOperation = ({ id, ...rest }: PriceListItemsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/price_list_items/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/price_list_items/{id}/' };
  };

/**
 * DELETE /dmx-server/price_list_items/{id}/
 *
 * ```yaml
 * operationId: price_list_items_destroy
 * tags:
 *   - price_list_items
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 *   '400':
 *     content:
 *       application/json:
 *         schema:
 *           type: array
 *           items:
 *             type: object
 *             properties:
 *               message:
 *                 type: string
 *               code:
 *                 type: string
 *             required:
 *               - message
 *               - code
 *     description: >-
 *       Položka je navázaná na výdejní sadu nebo objednávku služby/tisku — mazání
 *       je blokováno (code: vydej_price_list_item_in_use,
 *       vydej_price_list_item_in_use_by_service_order).
 * ```
 */
export const priceListItemsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PriceListItemsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = priceListItemsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
